import { CheckBoxWrapper, CheckText, ColumnsWrapper } from '../styles';

import Box from 'components/Box';
import Checkbox from 'components/Buttons/CheckboxButton';
import React from 'react';
import Toggle from 'components/Input/Toggle';
import utils from 'utils';

interface ReportColumns {
  label: string;
  name: string;
  value: boolean;
}

interface Props {
  selectItems: ReportColumns[];
  changeColumns: (checked: boolean, item: any) => void;
  visible?: boolean;
}

export default ({ selectItems, changeColumns, visible }: Props) => {
  const t = utils.intl.useTranslator();

  const handleChangeToggle = (a: any) => {
    selectItems.map((item) => changeColumns(a.currentTarget.checked, item));
  };

  return (
    <Box visible={visible} title={t('report-select-template')}>
      <div>
        <ColumnsWrapper>
          <div>
            <Toggle onChange={handleChangeToggle} checked={true} />
            <label>{t('report-select-all-columns')}</label>
          </div>
        </ColumnsWrapper>
        <ColumnsWrapper>
          {selectItems.map((item) => (
            <CheckBoxWrapper key={`${item.name}`}>
              <Checkbox
                key={`${item.name}.input`}
                action={(checked) => {
                  changeColumns(checked, item);
                }}
                name={item.name}
                isActive={item.value}
              />
              <CheckText key={`${item.name}.label`}>{t(item.label)}</CheckText>
            </CheckBoxWrapper>
          ))}
        </ColumnsWrapper>
      </div>
    </Box>
  );
};
